import { Snackbar, Alert } from '@mui/material';
import type { AlertColor } from '@mui/material';

type FuseMessageProps = {
	open?: boolean;
	message?: string;
	severity?: AlertColor;
	autoHideDuration?: number;
	onClose?: () => void;
};

/**
 * FuseMessage component
 * Global message/notification component
 */
function FuseMessage(props: FuseMessageProps) {
	const { open = false, message = '', severity = 'info', autoHideDuration = 6000, onClose } = props;

	if (!open && !message) {
		return null;
	}

	return (
		<Snackbar
			open={open || !!message}
			autoHideDuration={autoHideDuration}
			onClose={onClose}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
		>
			<Alert
				onClose={onClose}
				severity={severity}
				sx={{ width: '100%' }}
			>
				{message}
			</Alert>
		</Snackbar>
	);
}

export default FuseMessage;
